// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"3ffcbeae","504":"375cf2c4","808":"ec1ab607"}[chunkId] + ".chunk.js";
};